/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Coinvestments_Termsagreed_Indicativeorder_Description3Inputs */

const en_coinvestments_termsagreed_indicativeorder_description3 = /** @type {(inputs: Coinvestments_Termsagreed_Indicativeorder_Description3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Your non-binding investment indication of interest`)
};

/**
* | output |
* | --- |
* | "Your non-binding investment indication of interest" |
*
* @param {Coinvestments_Termsagreed_Indicativeorder_Description3Inputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const coinvestments_termsagreed_indicativeorder_description3 = /** @type {((inputs?: Coinvestments_Termsagreed_Indicativeorder_Description3Inputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Coinvestments_Termsagreed_Indicativeorder_Description3Inputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_coinvestments_termsagreed_indicativeorder_description3(inputs)
});
export { coinvestments_termsagreed_indicativeorder_description3 as "coInvestments_termsAgreed_indicativeOrder_description" }